export default {
  hello: 'Hello, {name}!',
  agenciesNoOptions: 'The user does not belong to any agency',
  selectAgency: 'Select your agency',
  agencies: 'Agencies',
  dashboard: 'Dashboard'
};
